<template>
    <div class="wrap">
        <div class="exports-wrap">
            <div class="line-item toolbar">
                <div class="left-item">
                </div>
            </div>
            <md-dialog :md-click-outside-to-close="false" :md-active.sync="showDeleteDialog">
                <md-dialog-title>
                    Confirm Delete
                </md-dialog-title>
                <md-dialog-content>
                    Are you sure you want to delete ? This action cannot be undone.
                </md-dialog-content>
                <md-dialog-actions class="full-btn">
                    <md-button class="ManualBtn ManualBtndelete" style="background-color: #d9534f !important;" @click="deleteSelectedExport(exportsId)">Delete</md-button>
                    <button class="ManualBtn ManualBtncancel extraClass" @click="closeDialogExport()">CANCEL</button>
                </md-dialog-actions>
            </md-dialog>
            <md-dialog :md-click-outside-to-close="false" :md-active.sync="showValidate">
                <md-dialog-title>
                    Confirm Delete
                </md-dialog-title>
                <md-dialog-content>
                    Are you sure you want to Validate this tour ?
                </md-dialog-content>
            </md-dialog>
            <div class="exports-wrap">
                <div v-if="elementNotVisible" style="float:right; background-color: #f8d7da !important;     border-color: #f5c6cb;     position: relative;    padding: .75rem 1.25rem;    margin-bottom: 1rem;    border: 2px solid transparent;    border-radius: .25rem;height: 25px; font-size: 16px; padding: 5px 0px; color: #721c24; margin-bottom:10px; "> {{ errormessageContent }}</div>
                <div v-if="elementVisible" style="float:right; background-color: #d4edda !important;     border-color: #c3e6cb;     position: relative;    padding: .75rem 1.25rem;    margin-bottom: 1rem;    border: 2px solid transparent;    border-radius: .25rem;height: 25px; font-size: 16px; padding: 5px 0px; color: #155724; margin-bottom:10px; "> Your File is valid</div>
                <loading
                    :active.sync="isLoading"
                    :can-cancel="true"
                    :is-full-page="fullPage"
                ></loading>
                <div v-if="exportListsWent">
                    <table id="firstTable">
                        <thead>
                        <tr>
                            <th>Export Id</th>
                            <th>Requested Time</th>
                            <th>Fulfilled Time</th>
                            <th>Export Tarball</th>
                            <th>Description</th>
                            <th>Status</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <p class="somethingWent"> Something went wroung</p>
                        </tbody>
                    </table>
                </div>
                <section class="page-content settings" v-else>
                    <table id="firstTable">
                        <thead>
                        <tr>
                            <th>Export Id</th>
                            <th>Requested Time</th>
                            <th>Fulfilled Time</th>
                            <th>Export Tarball</th>
                            <th>Description</th>
                            <th>Status</th>
                            <th>Delete</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="exports in exportLists" :key="exports.id" v-if="!exportDataNotFound">
                            <td>{{ exports.id }}</td>
                            <td>{{ exports.requested_time }}</td>
                            <td>{{ exports.fulfilled_time }}</td>
                            <td v-if="downloadAvailable(exports)">{{ 'appdata_client_' + exports.client_id + '_' + exports.id + '.tar.gz' }} &nbsp;&nbsp;&nbsp;<a :href="exports.file_url">Download</a></td>
                            <td v-else>{{ 'appdata_client_' + exports.client_id + '_' + exports.id + '.tar.gz' }}&nbsp;&nbsp;&nbsp;</td>
                            <td>{{ exports.tour_name }}</td>
                            <td v-if="exports.status == 1">
                                <span v-if="exports.exportErrorCheck ==0" style="color:rgb(0, 168, 202) !important;">
                                    Tour File is Valid
                                </span>
                                <span v-else>
                                    <span style="color:rgb(0, 168, 202) !important;" v-if="exports.export_error === 'Tar File is Valid'">
                                        {{ exports.export_error }}
                                    </span>
                                    <span v-else style="color:red;">
                                        Incomplete Tour
                                    </span>
                                </span>
                            </td>
                            <td v-else>Currently processing.</td>
                            <td>
                                <md-button class="md-icon-button" @click="confirmDelete(exports.id)">
                                    <md-icon>delete</md-icon>
                                </md-button>
                            </td>
                        </tr>
                        <tr v-if="exportDataNotFound" class="greenRecord"> Record not found.....</tr>
                        </tbody>
                    </table>
                </section>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
import axios from 'axios';
import {mapGetters, mapActions} from 'vuex';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  data () {
    return {
      exportId: '',
      errormessageContent: '',
      elementVisible: false,
      elementNotVisible: false,
      exportsId: '',
      showDeleteDialog: false,
      showValidate: false,
      filterString: '',
      exportLists: '',
      exportListsWent: false,
      exportDataNotFound: false,
      singleExport: '',
      isLoading: false
    };
  },
  computed: {
    ...mapGetters('client', ['clientActive', 'currentClient']),
    ...mapGetters('exports', ['exportsList'])
  },
  components: {
    Loading
  },
  methods: {
    ...mapActions('exports', ['loadExportsList']),
    ...mapActions('tours', ['loadClientToursList', 'exportToursDownload', 'emptyChecked']),
    loadExports () {
      if (this.clientActive) {
        this.loadExportsList(this.currentClient.id);
      } else {
        this.loadExportsList();
      }
    },
    validateTours (exportsId) {
      this.exportsId = exportsId;
      this.showValidate = true;
    },
    tourValidation (exportsId) {
      let p = this;
      axios.get('api/client/exports/validateTours/' + exportsId + '/', {}).then((response) => {
        if (response.data.message === 'INVALID') {
          p.getCLientExportList();
          p.showValidate = false;
          return false;
        } else {
          p.getCLientExportList();
          p.showValidate = false;
          return false;
        }
      }).catch((error) => {
        console.log(error);
      });
    },
    confirmDelete (exportsId) {
      this.exportsId = exportsId;
      this.showDeleteDialog = true;
    },
    async export_file (exportsId) {
      this.exportToursDownload({exportsId: exportsId});
    },
    closeDialogExport () {
      this.showDeleteDialog = false;
    },
    closeshowValidate () {
      this.showValidate = false;
    },
    deleteSelectedExport (exportsId) {
      axios.get('api/client/exports/delete/' + exportsId + '/', {}).then((response) => {
        this.getCLientExportList();
        this.showDeleteDialog = false;
      }).catch((error) => {
        console.log(error);
      });
    },
    showCurrentExportDetails (exportId) {
      axios.get('api/client/' + this.currentClient.id + '/exports/' + this.exportId, {}).then((response) => {
        this.singleExport = response.data;
      }).catch((error) => {
        console.log(error);
      });
    },
    getCLientExportList () {
      axios.get('api/client/' + this.currentClient.id + '/exports/', {}).then((response) => {
        this.isLoading = false;
        if (response.data === 1) {
          this.exportListsWent = true;
        } else {
          if (response.data.length === 0) {
            this.exportDataNotFound = true;
          } else {
            this.exportLists = response.data;
          }
        }
      }).catch((error) => {
        console.log(error);
      });
    },
    downloadAvailable: function (exports) {
      let isDownloadAvailable = false;
      if (exports.status === 1) {
        isDownloadAvailable = exports.export_error.includes('incomplete tour');
        if (exports.export_error.length === 0) {
          isDownloadAvailable = true;
        }
      }
      return isDownloadAvailable;
    }

  },
  mounted () {
    this.isLoading = true;
    this.getCLientExportList();
  }
};
</script>

<style scoped type="text/css">
.md-button:not([disabled])
.md-focused:before,
.md-button:not([disabled]):active:before,
.md-button:not([disabled]):hover:before {
    background-color: white !important;
    opacity: 0 !important;
}

.md-icon-button .md-ripple {
    border-radius: 0px !important;
    padding: 0px !important;
}

.exports-wrap .inner-line:hover {
    background-color: #EEEEEE;
}

.exports-wrap .search .search-glass-icon {
    position: absolute !important;
}

.exports-wrap .search .md-icon {
    height: 36px !important;
    font-size: 24px !important;
}

.exports-wrap .search {
    margin-top: 8px !important;

.md-input {
    width: 100% !important;
    padding-right: 36px !important;
}

}
.exports-wrap .search .md-button.md-icon-button {
    left: 0px !important;
    top: 0px !important;
}

.exports-wrap .search input {
    width: 360px;
    font-size: 100%;
}

.exports-wrap .upload-btn .file-input {
    position: absolute;
    left: -15px;
    height: 100px !important;
    width: 100px;
    opacity: 0;
}

.exports-wrap .toolbar .right-item {
    height: 48px;
    padding-top: 10px;
}

.exports-wrap .toolbar .right-item .upload-text {
    margin: 0px;
    padding: 0px;
    width: auto;
}

.upload-text {
    height: 75px;
    margin-left: 100px;
    width: 344px;
    display: inline-block;
}

.loading-icon {
    display: inline-block;
    width: 35px;
}

.fill-modal {
    width: 544px;
}

.tour-buttons .upload-btn {
    background-color: rgb(0, 168, 202) !important;
    color: rgba(255, 255, 255, 0.87) !important;
}

.bottom-btn-position {
    position: fixed !important;
    right: 12px !important;
    bottom: 32px !important;
    width: 500px;
    padding-right: 35px;

button {
    z-index: 15;
}

}
.wrap {
    padding-top: 0 !important;
}

.hovered-line:hover {
    background-color: rgba(0, 0, 0, 0.2);
}

.exports-item {
    cursor: pointer;
}

.line-item .left-item .el.mav-bar-export {
    margin-right: 200px;
}

table {
    font-family: 'Open Sans', sans-serif;
    width: 100%;
    border-collapse: collapse;
    margin: 10px 10px 0 10px;
}

table th {
    text-transform: uppercase;
    text-align: left;
    background: #00A8CA;
    color: #FFF;
    padding: 8px;
    min-width: 30px;
}

table td {
    text-align: left;
    padding: 8px;
    border-right: 2px solid #7D82A8;
    border-bottom: 2px solid #7D82A8;
}

table td:last-child {
    border-right: none;
}

table tbody tr:nth-child(2n) td {
    background: rgba(0, 0, 0, 0.2);
}

.ManualBtn {
    display: inline-block !important;
    margin-bottom: 0 !important;
    font-weight: 400 !important;
    text-align: center !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
    -ms-touch-action: manipulation !important;
    touch-action: manipulation !important;
    cursor: pointer !important;
    background-image: none !important;
    border: 1px solid transparent !important;
    padding: 6px 12px !important;
    font-size: 14px !important;
    line-height: 1.42857143 !important;
    border-radius: 4px !important;
    color: #fff !important;
}

.ManualBtndelete {
    background-color: #d9534f !important;
}

.ManualBtncancel {
    color: white !important;
    background-color: #00a8ca !important;
    border-color: #ccc !important;
    margin: 0 8px;
    float: left;
    width: 19%;
    padding: 8px !important;
}

.full-btn {
    padding-right: 20px !important;
    padding-left: 10px !important;
}

.greenRecord {
    color: green;
}

.somethingWent {
    color: red;
}

button.md-button.ManualBtn.ManualBtndelete.md-theme-default span.md-button-content {
    font-size: 15px;
}

button.md-button.ManualBtn.ManualBtncancel.md-theme-default span.md-button-content {
    font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/client/ExportsTab.vue